import {HttpClient} from "../../service/httpClient/HttpClient";
import {convertPersianDateToUniversalDate} from "@moeindal/base-raiko-panel-components";
import axios from "axios";

export class FundService {
    constructor() {
        this.httpClient = new HttpClient()
    }

    getSuperAdminInfo() {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `managers/total-owners`
            ).then(resolve).catch(reject)
        })
    }

    updateSuperAdmin(info) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `managers/total-owners`,
                {
                    "firstName": info.firstName,
                    "lastName": info.lastName,
                    "username": info.username,
                    "phoneNumber": info.phoneNumber,
                    "nationalCode": info.nationalCode,
                    "password": info.password && info.password.toString().length > 0 ? info.password : "",
                    "enabled": info.enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    createSuperAdmin(info) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `managers/total-owners`,
                {
                    "firstName": info.firstName,
                    "lastName": info.lastName,
                    "username": info.username,
                    "phoneNumber": info.phoneNumber,
                    "nationalCode": info.nationalCode,
                    "password": info.password && info.password.toString().length > 0 ? info.password : "",
                    "enabled": info.enabled
                }
            ).then(resolve).catch(reject)
        })
    }


    getFundsList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds`,
                {
                    page, size
                }
            ).then(resolve).catch(reject)
        })
    }

    createNewFund(name, groupCount, dayOfMeeting, fixedFeeRate, startDate, minimumAmount, lastDayForPay, address, status) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds`,
                {
                    "name": name,
                    "maximumGroupNumber": groupCount,
                    "dateOfMeetingPerMonth": dayOfMeeting,
                    "fixedFeeRate": fixedFeeRate,
                    "minimumAmountReceivedPerMonth": minimumAmount,
                    "theLastDayAllowedToReceiveSavingsPerMonth": lastDayForPay,
                    "activityStartDate": convertPersianDateToUniversalDate(startDate),
                    "enabled": status,
                    "postalAddress": address
                }
            ).then(resolve).catch(reject)
        })
    }

    getFundDetail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${id}`
            ).then(resolve).catch(reject)
        })
    }

    updateFundInfo(id, info) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `funds/${id}`,
                {
                    "name": info.name,
                    "maximumGroupNumber": info.maximumGroupNumber,
                    "dateOfMeetingPerMonth": info.dateOfMeetingPerMonth,
                    "fixedFeeRate": info.fixedFeeRate,
                    "minimumAmountReceivedPerMonth": info.minimumAmountReceivedPerMonth,
                    "theLastDayAllowedToReceiveSavingsPerMonth": info.theLastDayAllowedToReceiveSavingsPerMonth,
                    "activityStartDate": convertPersianDateToUniversalDate(info.activityStartDate),
                    "enabled": info.enabled,
                    "postalAddress": info.postalAddress
                }
            ).then(resolve).catch(reject)
        })
    }

    getFundGatewayList(id, page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `payment-gateways`,
                {
                    page, size,
                    "fund-id": id
                }
            ).then(resolve).catch(reject)
        })
    }

    getFundGatewayDetail(id) {
        const reqInformation = this.httpClient.get(`payment-gateways/${id}/information`)

        const reqEnabled = this.httpClient.get(`payment-gateways/${id}/enabled`)

        const reqToken = this.httpClient.get(`payment-gateways/${id}/token`)


        return new Promise((resolve, reject) => {
            axios.all([
                reqInformation,
                reqEnabled,
                reqToken
            ])
                .then(
                    axios.spread((information, enabled, token) => {
                        resolve(
                            {information, enabled, token}
                        )
                    }))
                .catch(reject)
        })
    }

    updateFundGateway(id, title, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `payment-gateways/${id}`,
                {
                    title, type
                }
            ).then(resolve).catch(reject)
        })
    }

    updateFundGatewayToken(id, token) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `payment-gateways/${id}/token`,
                {},
                {
                    token
                }
            ).then(resolve).catch(reject)
        })
    }

    updateFundGatewayEnabled(id, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.patch(
                `payment-gateways/${id}/enabled`,
                {},
                {
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    createNewGateway(id, title, type) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `funds/${id}/payment-gateways`,
                {
                    title,
                    type
                }
            ).then(resolve).catch(reject)
        })
    }

    getFundsAdminsList(page, size, fullName, nationalCode) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `managers`,
                {
                    page, size,
                    "full-name": fullName,
                    "national-code": nationalCode
                }
            ).then(resolve).catch(reject)
        })
    }

    CreateFundAdmin(firstName, lastName, nationalCode, phoneNumber, username, password, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.post(
                `managers`,
                {
                    firstName,
                    lastName,
                    username,
                    phoneNumber,
                    nationalCode,
                    password,
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    getFundAdminDetail(id) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `managers/${id}`
            ).then(resolve).catch(reject)
        })
    }

    updateFundAdmin(id, firstName, lastName, nationalCode, phoneNumber, username, password, enabled) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `managers/${id}`,
                {
                    firstName,
                    lastName,
                    username,
                    phoneNumber,
                    nationalCode,
                    password,
                    enabled
                }
            ).then(resolve).catch(reject)
        })
    }

    getFundAdminSelectedFund(id) {
        return new Promise((resolve, reject) => {

        })
    }

    updateFundAdminSelectedFund(id, fundId) {
        return new Promise((resolve, reject) => {
            this.httpClient.put(
                `managers/${id}/funds`,
                {
                    fundId
                }
            ).then(resolve).catch(reject)
        })
    }
}